export default __webpack_public_path__ + "static/media/b18.6d0b8517.jpg";